angular.module('inspecciones')
    .controller('historialdamageController', [
        '$rootScope', '$scope', '$location', '$route', '$routeParams',
        'inspeccionesService', 'infraestructurasAdminService', 'authenticationInfo', 'authenticationService',
        function ($rootScope, $scope, $location, $route, $routeParams,
            inspeccionesService, infraestructurasAdminService, authenticationInfo, authenticationService) {

            $scope.authentication = authenticationInfo;
            $scope.inspeccionId = $routeParams.inspeccionId;
            $scope.dañoId = $routeParams.id;

            $scope.danios = [];
            $scope.selectedDamage = null;

            // Cargar daños históricos
            inspeccionesService.getDañosCompletosPorCodigo($scope.dañoId).then(function (response) {
                $scope.danios = response.data;
                $scope.Codigo = $scope.danios[0].Codigo;

                $scope.danios.forEach(function (danio) {
                    inspeccionesService.getImagen(danio.Id).then(function (res) {
                        var blob = new Blob([res.data], { type: res.headers('Content-Type') });
                        var url = URL.createObjectURL(blob);
                        danio.Imagen = url; // asignamos la URL al objeto del daño
                    });
                });

                if ($scope.danios.length > 0) {
                    $scope.selectedDamage = $scope.danios[0]; // Selección inicial
                }
            });


            $scope.seleccionarDanio = function (danio) {
                $scope.selectedDamage = danio;
            };

            $scope.volver = function () {
                $location.path('/damages/' + $scope.inspeccionId + '/' + $scope.dañoId);
                $rootScope.inspeccionUrl = true;
                $rootScope.damageUrl = true;
            };

            $scope.verCategorias = function () {
                $rootScope.inspeccionUrl = false;
                $rootScope.parteUrl = false;
                $rootScope.parteUrl = false;
                $location.path('/categorias');
            };
        }
    ]);
